<!-- skipLinks -->
<div class="container"><a class="visually-hidden visually-hidden-focusable" href="#app-content">{{ resources.skipLinksText }}</a></div>

<!-- Logo -->
<div class="logo-container">
  <div class="wrapper">
    <a [routerLink]="['/']" [title]="resources.advieswijzerLogoLinkTitle" tabindex="-1" id="logo-link">
      <img [src]="logo" [alt]="resources.cibgLogoAlt" id="brand-logo">
    </a>
    <a [routerLink]="['/']" [title]="resources.advieswijzerLogoLinkTitle" tabindex="-1" id="logo-small-link">
      <img [src]="smallScreenLogo" [alt]="resources.cibgLogoAlt" id="brand-logo">
    </a>
  </div>
</div>

<!-- Titlebar -->
<div class="titlebar">
  <div class="container">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</div>
<ng-content></ng-content>

<ng-template #content>
  <div class="row">
    <div class="title col-md-7">
      <span id="sr-youarehere" class="visually-hidden d-none">{{resources.youAreHereSrOnly}}</span>
      @if (resources.bigRegisterTitle) {
        <a href="https://www.bigregister.nl"
          aria-labelledby="sr-youarehere">{{ resources.bigRegisterTitle }}
        </a>
      }
      @if (resources.subsiteTitle) {
        <span class="nowrap">{{ resources.subsiteTitle }}</span>
      }
      @if (version) {
        <span class="nowrap"> {{ version }}</span>
      }
    </div>
  </div>
</ng-template>
